<template>
  <div class="dashboard-layout">
    <div class="dashboard-topbar">
  <AppTopBar @logout="logout" />
</div>
<div class="dashboard-content">
  <WindowTray @minimize-window="minWindow" />
  <DockMenu :dialogs="window" />
  <router-view />
</div>
  <Toast />
  <Toast position="bottom-right" group="custom" class="toast-loading-host">
    <template #message="slotProps">
      <div v-if="slotProps.message.loading" class="flex gap-2">
        <SpinnerIcon spin class="mt-1" style="color: #5c697a" />
        <div class="text-left">
          <div class="" style="color: #5c697a">
            {{ slotProps.message.summary }}
          </div>
          <div v-if="slotProps.message.detail" style="color: #75808e">
            {{ slotProps.message.detail }}
          </div>
        </div>
      </div>
      <div v-else class="flex flex-column align-items-center" style="flex: 1">
        <div class="text-center">
          <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
          <div class="font-bold text-lg my-3">
            {{ slotProps.message.summary }}
          </div>
          <div class="my-3" v-html="slotProps.message.detail"></div>
        </div>
      </div>
    </template>
  </Toast>
  <!-- <ConfirmPopup /> -->
</div>
</template>
<script>
// Path: src\layouts\TheDefaultLayout.vue

import { defineComponent } from "vue";
import AppTopBar from "@/views/AppTopBar.vue";
import DockMenu from "@/views/DockMenu.vue";
import WindowTray from "@/components/core/WindowTray.vue";
import SpinnerIcon from "@primevue/icons/spinner";

export default {
  components: { AppTopBar, DockMenu, WindowTray, SpinnerIcon },
  name: "TheDefaultLayout",
};
</script>

<style scoped>
.dashboard-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.dashboard-content {
  padding-top: 44px;
}
</style>